import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/login", { password });
      setToken(data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen bg-white flex items-center justify-center px-6 py-12"
    >
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center mb-12">
          <div className="w-12 h-12 rounded-full border border-black/20 flex items-center justify-center">
            <Lock size={18} />
          </div>
        </div>
        <p className="overline text-center mb-4">Manzano Real Estate</p>
        <h1 className="font-heading text-4xl md:text-5xl text-center mb-12 tracking-tight">
          Admin <em className="italic font-light">Access</em>
        </h1>
        <form onSubmit={submit} className="space-y-8" data-testid="admin-login-form">
          <label className="block">
            <span className="block text-[10px] tracking-[0.28em] uppercase text-black/50 mb-3">
              Password
            </span>
            <input
              type="password"
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
              className="w-full bg-transparent border-0 border-b border-black/20 rounded-none px-0 py-3 text-base focus:outline-none focus:border-black transition-colors"
            />
          </label>
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center px-10 py-4 bg-black text-white border border-black text-[11px] uppercase tracking-[0.28em] font-medium hover:bg-white hover:text-black transition-all duration-500 disabled:opacity-50"
          >
            {busy ? "Verifying..." : "Sign In"}
          </button>
        </form>
        <p className="text-center text-xs text-black/40 mt-12 tracking-wider">
          Restricted access · Manzano Group
        </p>
      </div>
    </main>
  );
};

export default AdminLogin;
